// Keep long imports bounded without retaining heavyweight JSON number arrays.
export const MAX_SESSION_BYTES = 256 * 1024 * 1024;
export function compactRecording(recording) {
  let byteLength = 0;
  const leads = recording.leads.map((lead) => {
    const useInt32 = lead.samples.every(
      (sample) => Number.isInteger(sample) && sample >= -2147483648 && sample <= 2147483647
    );
    const samples = useInt32 ? Int32Array.from(lead.samples) : Float64Array.from(lead.samples);
    byteLength += samples.byteLength;
    return { ...lead, samples };
  });
  return { recording: { ...recording, leads }, byteLength };
}
